'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2; /**
                     * @file index
                     * @author Cuttle Cong
                     * @date 2018/9/11
                     *
                     */


exports.isNodeContains = isNodeContains;

var _prefixClassname = require('prefix-classname');

var _prefixClassname2 = _interopRequireDefault(_prefixClassname);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require('@rcp/util.createmount');

var _util2 = _interopRequireDefault(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof document === 'undefined' || typeof $ === 'undefined') {
  console.error('Error: [html-measure] requires zepto or jquery and in browser environment');
}

var PureComponent = React.PureComponent;

var cn = (0, _prefixClassname2.default)('');
var c = (0, _prefixClassname2.default)('html-measure__');

var attrExcludeSymbol = 'data-hm-exclude';

function isNodeContains(node) {
  return !node.hasAttribute(attrExcludeSymbol);
}

function padding(node, parent) {
  var rect1 = node.getBoundingClientRect();
  var rect2 = parent.getBoundingClientRect();
  var overlap = rect1.right < rect2.left || rect1.left > rect2.right || rect1.bottom < rect2.top || rect1.top > rect2.bottom;

  if (!overlap) {
    return {
      paddingTop: rect2.top - rect1.top,
      paddingBottom: rect1.bottom - rect2.bottom,
      paddingLeft: rect2.left - rect1.left,
      paddingRight: rect1.right - rect2.right
    };
  }
}

function _sz(pixel) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      unit = _ref.unit,
      numberFixed = _ref.numberFixed,
      isShowUnit = _ref.isShowUnit,
      remStandardPx = _ref.remStandardPx;

  if (isNaN(pixel) || pixel === '') {
    return null;
  }
  pixel = Number(pixel);

  if (unit === 'rem') {
    pixel = pixel / remStandardPx;
  }
  var decimal = parseFloat(Number(pixel).toFixed(numberFixed));
  // 10.2 -> 10.2;   10.0 -> 10
  decimal = decimal % 1 !== 0 ? decimal : Number(decimal).toFixed(0);
  return '' + decimal + (isShowUnit ? unit : '');
}

var Scene = (_temp2 = _class = function (_PureComponent) {
  _inherits(Scene, _PureComponent);

  function Scene() {
    var _temp, _this, _ret;

    _classCallCheck(this, Scene);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.scaleWidth = (0, _util2.default)(), _this.scaleHeight = (0, _util2.default)(), _this.scaleLeft = (0, _util2.default)(), _this.scaleRight = (0, _util2.default)(), _this.scaleTop = (0, _util2.default)(), _this.scaleBottom = (0, _util2.default)(), _this.dotRound = (0, _util2.default)(), _this.vRule = (0, _util2.default)(), _this.hRule = (0, _util2.default)(), _this.ruleBox = (0, _util2.default)(), _this.runtime = {
      ruleNode: null,
      selectedNode: null
    }, _this.handleLayerMouseOver = function (evt) {
      var target = evt.target;

      if (isNodeContains(target)) {
        if (_this.runtime.selectedNode === target) {
          _this.renderPixelSize();
          return;
        }

        _this.renderPixelDist();

        var _this$pos = _this.pos(target),
            left = _this$pos.left,
            top = _this$pos.top;

        var dom = _this.hRule.open({
          element: null,
          mountNode: _this.layerRef,
          attributes: {
            className: c('rule-h', 'rule')
          }
        });
        _this.hRule.dom = dom;
        $(dom).css({ left: left, width: $(target).width() }).show();

        dom = _this.vRule.open({
          element: null,
          mountNode: _this.layerRef,
          attributes: {
            className: c('rule-v', 'rule')
          }
        });
        _this.vRule.dom = dom;
        $(dom).css({ top: top, height: $(target).height() }).show();

        dom = _this.ruleBox.open({
          element: null,
          mountNode: _this.layerRef,
          attributes: {
            className: c('rule-box', 'rule')
          }
        });
        _this.ruleBox.dom = dom;
        $(dom).css({ top: top, left: left, height: $(target).height(), width: $(target).width() }).show();

        _this.runtime.ruleNode = target;
      }
    }, _this.handleLayerMouseOut = function (_ref2) {
      var target = _ref2.target;

      if (isNodeContains(target)) {
        if (_this.runtime.ruleNode === target) {
          $(_this.hRule.dom).hide();
          $(_this.vRule.dom).hide();
          $(_this.ruleBox.dom).hide();
          _this.runtime.ruleNode = null;
        }
      }
    }, _this.handleLayerClick = function (evt) {
      var target = evt.target;

      if (isNodeContains(target)) {
        typeof evt.preventDefault === 'function' && evt.preventDefault();

        var selectedClassName = c('selected');
        if (_this.runtime.selectedNode) {
          $(_this.runtime.selectedNode).removeClass(selectedClassName);
        }

        $(target).addClass(selectedClassName);
        _this.runtime.selectedNode = target;
        $(_this.scaleLeft.dom).hide();
        $(_this.scaleBottom.dom).hide();
        $(_this.scaleTop.dom).hide();
        $(_this.scaleRight.dom).hide();

        _this.renderPixelSize();

        if (_this.runtime.selectedNode === _this.runtime.ruleNode) {
          $(_this.vRule.dom).hide();
          $(_this.hRule.dom).hide();
          $(_this.ruleBox.dom).hide();
        }

        // render dot around
        var dom = _this.dotRound.open({
          element: React.createElement(
            'div',
            { className: c('dots') },
            React.createElement('div', { className: c('dot-lt', 'dot') }),
            React.createElement('div', { className: c('dot-rt', 'dot') }),
            React.createElement('div', { className: c('dot-rb', 'dot') }),
            React.createElement('div', { className: c('dot-lb', 'dot') })
          ),
          mountNode: _this.containerRef
        });
        _this.dotRound.dom = dom;
        var $t = $(target);
        $(dom).css(_extends({
          position: 'absolute',
          pointerEvents: 'none'
        }, _this.pos($t), {
          width: $t.width(),
          height: $t.height()
        })).show();

        if (typeof _this.props.onClickMeasureAbleNode === 'function') {
          _this.props.onClickMeasureAbleNode(target);
        }
      }
    }, _this.state = {
      width: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Scene.prototype.componentDidUpdate = function componentDidUpdate(old) {
    if (this.props.html !== old.html) {
      this.runtime = {};
      this.hide();
    }

    this.update();
  };

  Scene.prototype.sz = function sz() {
    var pixel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return _sz(pixel, this.props);
  };

  Scene.prototype.componentWillUnmount = function componentWillUnmount() {
    this.hide();
  };

  Scene.prototype.hide = function hide() {
    this.scaleWidth.close();
    this.scaleHeight.close();
    this.scaleTop.close();
    this.scaleLeft.close();
    this.scaleRight.close();
    this.scaleBottom.close();
    this.dotRound.close();
    this.ruleBox.close();
    this.vRule.close();
    this.hRule.close();
  };

  Scene.prototype.pos = function pos(node) {
    var offset = $(node).offset();
    var pOffset = $(this.layerRef).offset();
    return _extends({}, offset, {
      left: offset.left - pOffset.left,
      top: offset.top - pOffset.top
    });
  };

  Scene.prototype.renderPixelSize = function renderPixelSize() {
    var scaleGapPx = this.props.scaleGapPx;

    var $node = $(this.runtime.selectedNode);

    var _pos = this.pos($node),
        left = _pos.left,
        top = _pos.top;

    $(this.scaleWidth.dom).hide();
    $(this.scaleHeight.dom).hide();

    var dom = this.scaleWidth.open({
      element: React.createElement(
        'div',
        { className: c('scale-label') },
        this.sz($node.width())
      ),
      attributes: {},
      mountNode: this.containerRef
    });
    this.scaleWidth.dom = dom;
    $(dom).css({
      position: 'absolute',
      top: top - scaleGapPx + 'px',
      left: left + $node.width() / 2 + 'px',
      transform: 'translate(-50%, -100%)'
    }).show();

    dom = this.scaleHeight.open({
      element: React.createElement(
        'div',
        { className: c('scale-label') },
        this.sz($node.height())
      ),
      attributes: {},
      mountNode: this.containerRef
    });
    this.scaleHeight.dom = dom;
    $(dom).css({
      position: 'absolute',
      top: top + $node.height() / 2 + 'px',
      left: left + $node.width() + scaleGapPx + 'px',
      transform: 'translate(0%, -50%)'
    }).show();
  };

  Scene.prototype.renderPixelDist = function renderPixelDist() {
    var _runtime = this.runtime,
        selectedNode = _runtime.selectedNode,
        ruleNode = _runtime.ruleNode;

    if (selectedNode && ruleNode && selectedNode !== ruleNode) {
      var $selectedNode = $(selectedNode);
      var $ruleNode = $(ruleNode);

      $(this.scaleHeight.dom).hide();
      $(this.scaleWidth.dom).hide();

      $(this.scaleLeft.dom).hide();
      $(this.scaleBottom.dom).hide();
      $(this.scaleTop.dom).hide();
      $(this.scaleRight.dom).hide();

      var _ref3 = padding(ruleNode, selectedNode) || {},
          paddingLeft = _ref3.paddingLeft,
          paddingRight = _ref3.paddingRight,
          paddingTop = _ref3.paddingTop,
          paddingBottom = _ref3.paddingBottom;

      var selPos = this.pos($selectedNode);
      var rulePos = this.pos($ruleNode);

      var leftDist = paddingLeft > 0 ? paddingLeft : selPos.left - rulePos.left - $ruleNode.width();
      var rightDist = paddingRight > 0 ? paddingRight : rulePos.left - selPos.left - $selectedNode.width();
      var topDist = paddingTop > 0 ? paddingTop : selPos.top - rulePos.top - $ruleNode.height();
      var bottomDist = paddingBottom > 0 ? paddingBottom : rulePos.top - selPos.top - $selectedNode.height();

      var dom = void 0;
      if (leftDist > 0) {
        dom = this.scaleLeft.open({
          element: React.createElement(
            'div',
            {
              style: {
                transform: 'translateY(-100%)',
                position: 'relative',
                bottom: this.props.scaleGapPx
              },
              className: c('scale-label')
            },
            this.sz(leftDist)
          ),
          attributes: {
            className: c('scale-line', 'scale-line-v')
          },
          mountNode: this.containerRef
        });
        this.scaleLeft.dom = dom;

        $(dom).css({
          top: selPos.top + $selectedNode.height() / 2,
          left: selPos.left - leftDist,
          width: leftDist - 1
        }).show();
      }

      if (rightDist > 0) {
        dom = this.scaleRight.open({
          element: React.createElement(
            'div',
            {
              style: {
                transform: 'translateY(-100%)',
                position: 'relative',
                bottom: this.props.scaleGapPx
              },
              className: c('scale-label')
            },
            this.sz(rightDist)
          ),
          attributes: {
            className: c('scale-line', 'scale-line-v')
          },
          mountNode: this.containerRef
        });
        this.scaleRight.dom = dom;

        $(dom).css({
          top: selPos.top + $selectedNode.height() / 2,
          left: selPos.left + $selectedNode.width(),
          width: rightDist
        }).show();
      }

      if (topDist > 0) {
        dom = this.scaleTop.open({
          element: React.createElement(
            'div',
            {
              style: {
                position: 'relative',
                left: this.props.scaleGapPx,
                top: topDist / 2,
                transform: 'translateY(-50%)'
              },
              className: c('scale-label')
            },
            this.sz(topDist)
          ),
          attributes: {
            className: c('scale-line', 'scale-line-h')
          },
          mountNode: this.containerRef
        });
        this.scaleTop.dom = dom;

        $(dom).css({
          top: selPos.top - topDist,
          height: topDist - 1,
          left: selPos.left + $selectedNode.width() / 2
        }).show();
      }

      if (bottomDist > 0) {
        dom = this.scaleBottom.open({
          element: React.createElement(
            'div',
            {
              style: {
                position: 'relative',
                left: this.props.scaleGapPx,
                top: bottomDist / 2,
                transform: 'translateY(-50%)'
              },
              className: c('scale-label')
            },
            this.sz(bottomDist)
          ),
          attributes: {
            className: c('scale-line', 'scale-line-h')
          },
          mountNode: this.containerRef
        });
        this.scaleBottom.dom = dom;

        $(dom).css({
          top: selPos.top + $selectedNode.height(),
          height: bottomDist,
          left: selPos.left + $selectedNode.width() / 2
        }).show();
      }
    }
  };

  Scene.prototype.update = function update() {
    this.runtime.selectedNode && this.handleLayerClick({ target: this.runtime.selectedNode });
    this.runtime.ruleNode && this.handleLayerMouseOver({ target: this.runtime.ruleNode });
    this._updateWidth();
  };

  Scene.prototype._updateWidth = function _updateWidth() {
    if (this.props.isCalcContainerWidth && this.layerRef && this.layerRef.clientWidth !== this.state.width) {
      this.setState({ width: this.layerRef.clientWidth });
    }
  };

  Scene.prototype.componentDidMount = function componentDidMount() {
    this._updateWidth();
  };

  Scene.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        html = _props.html,
        children = _props.children,
        style = _props.style,
        isCalcContainerWidth = _props.isCalcContainerWidth,
        className = _props.className;


    var props = {};
    if (typeof html === 'string') {
      props.dangerouslySetInnerHTML = {
        __html: html
      };
      children = undefined;
    }

    return React.createElement(
      'div',
      {
        ref: function ref(r) {
          return _this2.containerRef = r;
        },
        className: cn(c('container'), className),
        style: _extends({
          width: this.state.width
        }, style)
      },
      React.createElement(
        'div',
        _extends({
          onMouseMove: this.handleLayerMouseOver,
          onMouseOut: this.handleLayerMouseOut,
          onClick: this.handleLayerClick,
          ref: function ref(r) {
            return _this2.layerRef = r;
          },
          className: c('layer')
        }, props),
        children
      )
    );
  };

  return Scene;
}(PureComponent), _class.sz = _sz, _class.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  html: _propTypes2.default.string,
  unit: _propTypes2.default.oneOf(['px', 'rem']),
  remStandardPx: _propTypes2.default.number,
  scaleGapPx: _propTypes2.default.number,
  numberFixed: _propTypes2.default.number,
  isShowUnit: _propTypes2.default.bool,
  isCalcContainerWidth: _propTypes2.default.bool,
  onClickMeasureAbleNode: _propTypes2.default.func
}, _class.defaultProps = {
  unit: 'px',
  remStandardPx: 16,
  scaleGapPx: 10,
  numberFixed: 0,
  isShowUnit: true,
  isCalcContainerWidth: true
}, _temp2);
exports.default = Scene;